module.exports = __webpack_public_path__ + "images/pages/line_friend_lp/mv-back-image_280cd6a34b9b88ed2ff2757b55ecfda3.png";